import { Summary } from "@repo/apis/bag";
import { BagSdkMethod } from "../utils/method-initialiser";

export type ItemCount = {
  total: number;
} | null;

type PublicGetItemCountMethod = () => ItemCount;
type GetItemCountMethod = BagSdkMethod<PublicGetItemCountMethod>;

export const getItemCountInitialiser: GetItemCountMethod =
  ({ state }) =>
  () => {
    const bag = state.getBag();

    if (!bag || !bag.summary) {
      return null;
    }

    return {
      total: (bag.summary as Summary).totalQuantity,
    };
  };
